import React from 'react';
import { Box, Image, Text } from '@chakra-ui/react';

const LogoSection = () => (
  <Box textAlign="center" mb={2}>
    <Image
      src="/png/osspid-logo.png"
      alt="Logo"
      mx="auto"
      h="48px"
      mb={1}
    />
    {/* <Text fontWeight="bold" fontSize="xl" color="green.600" letterSpacing="2px">YOURBRAND</Text> */}
  </Box>
);

export default LogoSection; 